import React, { useState, useCallback } from "react";

import * as firebase from "firebase/app";
import "firebase/firestore";

import { useCollectionData } from "react-firebase-hooks/firestore";
import { Dropdown } from "react-bootstrap";

const AddIdPlayer = (props) => {
  const [contacts] = useCollectionData(
    firebase.firestore().collection(`contacts`)
  );

  const [selectContact, setSelectContact] = useState("");
  const [inputIdPlayer, setInputIdPlayer] = useState("");

  const submitAddIdPlayer = useCallback(
    (e) => {
      e.preventDefault();

      if (selectContact && inputIdPlayer) {
        let player_ids = props.player_ids;

        player_ids.push({
          contact_id: selectContact.id,
          player_id: inputIdPlayer,
        });

        firebase.firestore().doc(`users/${props.userId}`).update({
          player_ids: player_ids,
        });

        props.setAddPlayerIdTrigger(false);
      }
    },
    [selectContact, inputIdPlayer, props]
  );

  return (
    <>
      {contacts && (
        <div className="idPlayer__el idPlayer__el--addId ">
          <Dropdown>
            <Dropdown.Toggle
              drop="up"
              className={`idPlayer__dropBtn ${
                selectContact && "idPlayer__dropBtn--select idPlayer__img"
              }  `}
              as="button"
            >
              {selectContact && (
                <img
                  src={require(`../../../../assets/img/${selectContact.vignette_url}`)}
                  alt={selectContact.name}
                />
              )}
            </Dropdown.Toggle>
            <Dropdown.Menu as="ul">
              {contacts.map((contact, key) => (
                <Dropdown.Item
                  key={key}
                  as="li"
                  onClick={() => setSelectContact(contact)}
                >
                  <div className="idPlayer__img">
                    <img
                      src={require(`../../../../assets/img/${contact.vignette_url}`)}
                      alt={contact.name}
                    />
                  </div>
                  <span>{contact.name}</span>
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
          <form
            onSubmit={(e) => submitAddIdPlayer(e)}
            className="idPlayer__form"
          >
            <input
              onChange={(e) => setInputIdPlayer(e.target.value)}
              type="text"
              placeholder="Pseudo#123"
              required
            />
            <button type="submit">OK</button>
          </form>
        </div>
      )}
    </>
  );
};

export default AddIdPlayer;
